<content>
  <form *ngIf="!verification && !forgotPasswd && !showRoles" [formGroup]="loginForm" [ngClass]="{'show-error': showError}">
    <div class="entry">
      <label>{{ 'session.user' | translate}} *</label>
      <input type="text" formControlName="userName">
    </div>
    <div class="entry">
      <label>{{'session.password' | translate}} *</label>
      <input [type]="showPassword ? 'text' : 'password'" formControlName="password">
      <span>
        <i [ngClass]="showPassword ? 'fa fa-eye-slash': 'fa fa-eye'" (click)="showPassword = !showPassword"
            title="{{ showPassword ? ('session.hidePassword' | translate) : ('session.showPassword' | translate)}}"></i>
      </span>
    </div>
    <div class="entry">
      <a (click)="forgotPasswd=true">{{'session.forgotPassword' | translate}}</a>
    </div>
    <div class="entry">
      <input type="checkbox" id="keepSession" formControlName="keepSession">
      <label for="keepSession">{{'session.keepSession' | translate}}</label>
    </div>
  </form>
  <form *ngIf="forgotPasswd" [formGroup]="forgotPasswordForm" [ngClass]="{'show-error': showError}">
    <div class="entry">
      <p class="info">{{'session.forgotPasswordMsg' | translate}}</p>
    </div>
    <div class="entry">
      <label>{{'session.email' | translate}} *</label>
      <input type="text" formControlName="email">
    </div>
  </form>
  <form *ngIf="verification" [formGroup]="verificationCodeForm" [ngClass]="{'show-error': showError}">
    <div class="entry">
      <label>{{'session.verificationCode' | translate}} *</label>
      <input type="text" formControlName="verificationCode">
    </div>
  </form>
  <form *ngIf="showRoles" [formGroup]="rolesForm" [ngClass]="{'show-error': showError}">
    <div class="entry">
      <label>{{'session.chooseRole' | translate}} *</label>
      <app-filterable-list [itemsList]="roles" [selectedItem]="rolesForm.get('rol')" [placeHolder]="false">
      </app-filterable-list>
  </div>
  </form>
</content>
<footer>
  <button *ngIf="!verification && !forgotPasswd" (click)="showRoles ? loginWithRol() : checkLogin()">{{ 'session.login' | translate}}</button>
  <button *ngIf="verification" (click)="sendVerification()">{{ 'global.confirmar' | translate}}</button>
  <button *ngIf="forgotPasswd" (click)="sendEmail();">{{ 'global.enviar' | translate}}</button>
</footer>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
